import { Link } from 'react-router-dom';
import { Button, styled } from '@mui/material';

export const ViewMoreLinkWrapper = styled(Link)(({ theme }) => ({
  color                : theme.palette.primary.lightBlue1,
  fontFamily           : 'Montserrat',
  fontWeight           : '700',
  fontSize             : '14px',
  lineHeight           : '24px',
  textDecoration       : 'none',
  'span:first-of-type' : {
    marginRight : '10px',
  },
}));

export const ExternalLinkLinkWrapper = styled('a')(({ theme }) => ({
  color                : theme.palette.primary.lightBlue1,
  fontFamily           : 'Montserrat',
  fontWeight           : '700',
  fontSize             : '14px',
  lineHeight           : '24px',
  textDecoration       : 'none',
  'span:first-of-type' : {
    marginRight : '10px',
  },
}));

export const StyledButtonLink = styled(Button)(({ theme }) => ({
  color                : theme.palette.primary.lightBlue1,
  fontFamily           : 'Montserrat',
  fontSize             : '16px',
  textDecoration       : 'none',
  padding              : 0,
  textTransform        : 'inherit',
  lineHeight           : 'inherit',
  'span:first-of-type' : {
    marginRight : '10px',
  },
  '&[disabled]' : {
    color         : theme.palette.action.disabled,
    pointerEvents : 'none',
  },
  '&:hover' : {
    background : 'none',
  },
}));
